import styled from 'styled-components';

export const FooterContainer = styled.div`
  display: block;
  background-color: var(--footer-blue);
  color: var(--logo-gray);
  padding: 30px;
  font-size: 12px;
  line-height: 20px;
  margin-top: auto;
`;

export const FooterLogo = styled.div`
  display: inline-block;
  position: absolute;
  width: 80px;
  vertical-align: top;
  img {
    width: 100%;
  }
`;

export const FooterText = styled.div`
  display: inline-block;
  height: 100%;
  width: 100%;
  min-width: 200px;
  text-align: center;
`;
